export const wssUrl = () => {
    if (process.env.NODE_ENV === "development") {
        // ws.url = `ws://127.0.0.1:2346`
        return `wss://dyyun.e-class.me/wss`
    } else {
        return location.protocol === "https:" 
            ? `wss://${location.host}/wss` 
            : `ws://${location.host}/wss`
    }

}
